import * as Yup from 'yup';
import { addDays } from '../../../../../global/helpers/form-data-helper';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { EmploymentProps } from '../../../models/arc-epi-props';

export interface PositionFormValues {
	hire_date?: string;
	position_title: string;
	published_title: string;
	start_date: string;
	end_date?: string;
}

export const PositionFormValidationSchema = (employmentProps: EmploymentProps,
	labelSettings: LabelSettingProps,
	isEdit: boolean,
	isStip: boolean,
	firstNonStip: boolean,
	currentRecordCompareDate: string) => {

	const baseStartDate = Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, employmentProps.positionStartDateLabel));

	const minDateSchema = (() => {
		if (firstNonStip) {
			return baseStartDate.min(Yup.ref('hire_date'), employmentProps?.startDateBeforeHireDateError || 'Start date cannot be before non-stipendiary start date');
		}
		if (!isEdit && isStip) {
			return baseStartDate.min(addDays(currentRecordCompareDate, 1), employmentProps?.positionDateOverlapErrorMessage || 'Start date must be after current record start and end date');
		}

		return baseStartDate;
	})();

	return Yup.object().shape({
		hire_date: firstNonStip ? Yup.date().nullable().required(getRequiredText(labelSettings?.requiredFormat, employmentProps?.nonStipStartDateLabel)) : Yup.date().nullable(),
		position_title: Yup.string().required(getRequiredText(labelSettings?.requiredFormat, employmentProps?.positionTitleLabel)),
		start_date: minDateSchema,
		end_date: isStip ? Yup.date().nullable() : Yup.date().nullable().notRequired().min(Yup.ref('start_date'), labelSettings?.endDateBeforeStartDateError || 'End date cannot be before the start date'),
	});
};


export const layStatus = 'Lay';